var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverCardFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.54 18.125h-1.5a3.75 3.75 0 0 0-3.75-3.75h-3a3.75 3.75 0 0 0-3.75 3.75h-1.5v-2.25a6.75 6.75 0 0 1 13.5 0v2.25zm-8.25-5.25h3a5.183 5.183 0 0 1 3.473 1.32 5.25 5.25 0 0 0-9.946-.008 5.25 5.25 0 0 1 3.473-1.312z",
    fill: "#4C565C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.79 27.125a6.75 6.75 0 0 1-6.75-6.75v-2.25a5.25 5.25 0 0 1 5.25-5.25h3a5.25 5.25 0 0 1 5.25 5.25v2.25a6.75 6.75 0 0 1-6.75 6.75zm-1.5-12.75a3.75 3.75 0 0 0-3.75 3.75v2.25a5.25 5.25 0 0 0 10.5 0v-2.25a3.75 3.75 0 0 0-3.75-3.75h-3z",
    fill: "#4C565C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.79 42.875c-8.497 0-16.5-3.803-16.5-6.75.001-.23.05-.458.143-.668l.855-3.42a7.5 7.5 0 0 1 6.502-5.625V14.375a9 9 0 0 1 9.165-9 9.188 9.188 0 0 1 8.835 9.27v11.767a7.499 7.499 0 0 1 6.502 5.625l.855 3.42c.093.21.142.438.143.668 0 2.947-8.002 6.75-16.5 6.75zm0-36a7.5 7.5 0 0 0-7.5 7.5v12.75a.75.75 0 0 1-.75.75 6 6 0 0 0-5.797 4.5l-.87 3.487a.807.807 0 0 1-.053.143.284.284 0 0 0-.03.12c0 1.267 6.225 5.25 15 5.25s15-3.983 15-5.25a.285.285 0 0 0 0-.098.815.815 0 0 1-.053-.142l-.9-3.51a6 6 0 0 0-5.797-4.5.75.75 0 0 1-.75-.75v-12.48a7.68 7.68 0 0 0-7.357-7.77h-.143z",
    fill: "#4C565C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.79 33.875c-4.965 0-9-2.858-9-6.375a.75.75 0 0 1 1.5 0c0 2.685 3.367 4.875 7.5 4.875a.75.75 0 1 1 0 1.5z",
    fill: "#4C565C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverCardFemaleIcon);
export default __webpack_public_path__ + "static/media/driver-card-female-icon.08042cfea8d73665787be806ca582a0f.svg";
export { ForwardRef as ReactComponent };